import { loader } from 'graphql.macro'

export default function initializeForgotPassword ({ dataLoaders, variables }) {
  const schema = loader('./initializeForgotPassword.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { input: { ...variables } })
}
